/**
 * Module to handle setting up MutationObserver
 * @module
 */

var DocumentEnv = require('core/env/document');
var EventEmitter = require('core/event_emitter');
var MutationObserverEnv = require('core/env/mutation_observer');

/**
 * Creates a MutationObserver to observe any changes to the DOM.
 * Emits a DOMChangedEvent upon changes.
 */
exports.createDOMChangedObserver = function() {
  var MUTATION_OBSERVER_TARGET = DocumentEnv.getDocumentElement();
  var DOMChangedEvent = {type: 'viewTrigger', name: 'DOMChanged'};
  var config = {
    attributes: true,
    childList: true,
    subtree: true,  // This is expensive, but required to cover changes to window.document's descendants.
    characterData: true,
  };

  var observer = MutationObserverEnv.create(function() {
    EventEmitter.emit(DOMChangedEvent, true);
  });
  MutationObserverEnv.observe(observer, MUTATION_OBSERVER_TARGET, config);
};

